import type {
  BetterstartCommandRuntime,
  UpdateStylesCommandOptions
} from '@cli-types/core-engine/commands.js'
import { Command } from 'commander'

export function createUpdateStylesCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('update-styles')
    .description('Replace admin-globals.css with the latest version from the CLI')
    .option('--cwd <path>', 'Project root path')
    .action((options: UpdateStylesCommandOptions) => runtime.runUpdateStyles(options))
}
